import { useMutation } from '@tanstack/react-query';

export function useCreateUserInviteMutation() {
  return useMutation({
    mutationFn: async ({ userId }) => {
      const response = await axios.post(`/users/${userId}/invites`);

      return response.data;
    },
  });
}
